"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _commonField = _interopRequireDefault(require("./common-field"));

var _component = _interopRequireDefault(require("../component"));

var _attach = _interopRequireDefault(require("../attach"));

var _flexBreak = _interopRequireDefault(require("../flex-break"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    root: {
      marginLeft: theme.spacing(2),
      // The following flex properties are needed so that we can set a margin for all fields in the
      // nested form
      display: 'flex',
      flexFlow: 'wrap'
    }
  };
};

var FormField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(FormField, _React$PureComponent);

  var _super = _createSuper(FormField);

  function FormField() {
    (0, _classCallCheck2.default)(this, FormField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          hideLabel = _this$props.hideLabel,
          classes = _this$props.classes,
          disabled = _this$props.disabled;
      var isBlank = component.isBlank();
      var form = component.get('form');
      return /*#__PURE__*/_react.default.createElement("span", null, !hideLabel && /*#__PURE__*/_react.default.createElement(_commonField.default, {
        component: component,
        inlineLabel: "true",
        shrinkLabel: !isBlank,
        marginBottom: false
      }), /*#__PURE__*/_react.default.createElement(_flexBreak.default, null), /*#__PURE__*/_react.default.createElement("span", {
        className: classes.root
      }, /*#__PURE__*/_react.default.createElement(_component.default, {
        component: form,
        formTag: false,
        disabled: disabled
      })));
    }
  }]);
  return FormField;
}(_react.default.PureComponent);

FormField = (0, _withStyles.default)(styles)(FormField);

var _default = (0, _attach.default)(['hideLabel', 'value' // Changes when the value is or isn't blank
])(FormField);

exports.default = _default;